"use client";

import React from "react";
import * as S from "./styles";

type RowProps = {
  children: React.ReactNode;
  className?: string;
};

const Row: React.FC<RowProps> = ({ children, className }) => {
  return <S.Row className={className}>{children}</S.Row>;
};

export default Row;
